import { render, staticRenderFns } from "./DotIcon.vue?vue&type=template&id=d7f24c9c&scoped=true&"
import script from "./DotIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DotIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f24c9c",
  null
  
)

export default component.exports